import React from 'react'

import { Text } from '@interco/inter-toranja'
import {
  TextType,
  TextSize,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import type { SDUIComponentProps } from '../interfaces'
import * as S from './styles'

interface SectionHeaderSDUIProps {
  sduiComponent?: SDUIComponentProps
}

export const SectionHeaderSDUI: React.FC<SectionHeaderSDUIProps> = ({ sduiComponent }) => {
  if (!sduiComponent) return <></>

  return (
    <S.ContainerSectionHeader
      style={{
        marginTop: sduiComponent.style?.marginTop,
        marginBottom: sduiComponent.style?.marginBottom,
      }}
    >
      <Text
        textType={TextType.Title}
        textSize={TextSize.Small}
        textWeight={TextWeight.Bold}
        colorVariant="primary"
        as="h1"
      >
        {sduiComponent?.props?.title}
      </Text>
    </S.ContainerSectionHeader>
  )
}
